<template>
    <div class="button outlined" @click="showModal()">問い合わせ</div>
    <div class="form" v-if="show">
        <div class="box">
            <div class="header">
                <h2>店舗へのお問い合わせ</h2>
                <div class="close" @click=" closeModal()"></div>
            </div>
            <ol class="stepper">
                <li :class="index === 0 ? 'active' : ''">入力</li>
                <li :class="index === 1 ? 'active' : ''">確認</li>
                <li :class="index === 2 ? 'active' : ''">完了</li>
            </ol>
            <div ref="slider" class="contents keen-slider">
                <div class="reserveForms">
                    <div class="inputs">
                        <h3>店舗名</h3>
                        <p>{{ shop.name }}</p>

                        <h3>お客様情報</h3>
                        <label class="required">氏名</label>
                        <div class="textRow">
                            <input type="text" v-model="params.last_name" name="last_name" placeholder="例）田中"
                                :class="{ 'error': errors.name }">
                            <input type="text" v-model="params.first_name" name="first_name" placeholder="例）あおい"
                                :class="{ 'error': errors.name }">
                        </div>
                        <p v-for="error in errors.name" class="formError">{{ error }}</p>
                        <label class="required">氏名（ローマ字）</label>
                        <div class="textRow">
                            <input type="text" v-model="params.last_name_romaji" name="last_name_romaji"
                                placeholder="例）TANAKA" :class="{ 'error': errors.name_romaji }">
                            <input type="text" v-model="params.first_name_romaji" name="first_name_romaji"
                                placeholder="例）AOI" :class="{ 'error': errors.name_romaji }">
                        </div>
                        <p v-for="error in errors.name_romaji" class="formError">{{ error }}</p>
                        <label class="required">電話番号</label>
                        <input type="text" v-model="params.tel" name="tel" placeholder="例）00000000000"
                            :class="{ 'error': errors.tel }">
                        <p v-for="error in errors.tel" class="formError">{{ error }}</p>
                        <label class="required">メールアドレス</label>
                        <input type="text" v-model="params.email" name="email" placeholder="例）mail@example.com"
                            :class="{ 'error': errors.email }">
                        <p v-for="error in errors.email" class="formError">{{ error }}</p>
                        <label class="required">メールアドレス（確認用）</label>
                        <input type="text" v-model="email_confirmation" name="confirmation" placeholder="もう一度入力してください"
                            :class="{ 'error': errors.email_confirmation }">
                        <p v-for="error in errors.email_confirmation" class="formError">{{ error }}</p>
                        <label class="required">宿泊先名</label>
                        <input type="text" v-model="params.hotel_name" name="hotel_name" placeholder="例）◯◯ホテル"
                            :class="{ 'error': errors.hotel_name }">
                        <p v-for="error in errors.hotel_name" class="formError">{{ error }}</p>
                        <label class="required">お問い合わせ内容</label>
                        <textarea v-model="params.content" name="content" cols="30" rows="10" placeholder="入力してください"
                            :class="{ 'error': errors.content }"></textarea>
                        <p v-for="error in errors.content" class="formError">{{ error }}</p>
                    </div>
                    <div class="next">
                        <div class="button" @click="next(1)">お問い合わせ内容を確認する</div>
                    </div>
                </div>
                <div class="confirm">
                    <div class="inputs">
                        <div class="heading">
                            <h3>まだお問い合わせは完了していません</h3>
                            <p>お問い合わせ内容の最終確認をしてください</p>
                        </div>
                        <h3>お問い合わせ内容</h3>
                        <p>{{ params.content }}</p>
                        <h3>お客様情報</h3>
                        <table>
                            <tr>
                                <th>氏名</th>
                                <td>{{ params.last_name }} {{ params.first_name }}</td>
                            </tr>
                            <tr>
                                <th>氏名（ローマ字）</th>
                                <td>{{ params.last_name_romaji }} {{ params.first_name_romaji }}</td>
                            </tr>
                            <tr>
                                <th>電話番号</th>
                                <td>{{ params.tel }}</td>
                            </tr>
                            <tr>
                                <th>メールアドレス</th>
                                <td>{{ params.email }}</td>
                            </tr>
                            <tr>
                                <th>宿泊先名</th>
                                <td>{{ params.hotel_name }}</td>
                            </tr>
                        </table>
                        <div class="notice">
                          <h4>注意事項</h4>
                          <p>※必ずPCメールアドレスをご記入ください。携帯メールアドレス（docomoやsoftbankなど）では海外からのメールが受信拒否され、メールが届かない可能性がございます。</p>
                          <p>※メールを送信してから48時間経っても返信がない場合は、恐れ入りますが、店舗宛にメールを再送いただくか、お電話にてお問い合わせください。</p>
                        </div>
                        <div class="button outlined confirm" @click="prev(0)">入力内容を変更する</div>
                    </div>
                    <div class="next">
                        <div class="terms">
                          <a href="/privacy_policy" target="_blank" rel="noopener">プライバシーポリシー</a>
                          及び
                          <a href="/tos" target="_blank" rel="noopener">利用規約</a>
                        </div>
                        <div class="button submitButton" :class="{ 'disabled': disabled_flg }" @click="next(2)">上記に同意の上、送信する</div>
                    </div>
                </div>
                <div class="complete">
                    <div class="icon"></div>
                    <h3>お問い合わせいただきありがとうございました</h3>
                    <p>店舗からの連絡をお待ちください。</p>
                    <div class="button outlined"><a href="">店舗トップへ戻る</a></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        shop: Object
    },
    data() {
        return {
            show: false,
            slide: null,
            index: 0,
            params: {
                shop_id: '',
                user_id: '',
                number: '',
                status: 1,
                last_name: '',
                first_name: '',
                last_name_romaji: '',
                first_name_romaji: '',
                email: '',
                tel: '',
                hotel_name: '',
                content: ''
            },
            email_confirmation: '',
            disabled_flg: false,
            errors: {}
        }
    },
    mounted() {
        const content = document.querySelector('.reservation')
        if (content) {
            this.params.shop_id = this.shop.id
            this.initSlide()
        }
    },
    methods: {
        showModal() {
            const topSlider = document.querySelectorAll('.topSlider')[0]
            if (topSlider) {
                topSlider.classList.add('hidden')
            }
            this.show = true
            this.errors = {}
        },
        closeModal() {
            const topSlider = document.querySelectorAll('.topSlider')[0]
            if (topSlider) {
                topSlider.classList.remove('hidden')
            }
            this.show = false
        },
        initSlide() {
            const sliderUl = this.$refs.slider
            if (!sliderUl) return
            const childrenArray = Array.from(sliderUl.children)
            this.slide = KeenSlider(this.$refs.slider, {
                initial: this.index,
                drag: false,
                slides: {
                    perView: 1
                },
                selector: childrenArray
            })
            this.slide.on('slideChanged', (instance) => {
                const current = instance.track.details.abs
                this.index = current
            })
        },
        async next(number) {
            // 予約内容確認ページ遷移前にバリデーションチェックを挟む
            if (number === 1) {
                let res = await this.checkValidation()
                if (res) {
                    this.slide.next('slideChanged', () => {
                        this.index = number
                    })
                }
            }
            if (number === 2) {
                await this.save(number)
            }
        },
        prev(number) {
            this.slide.prev('slideChanged', () => {
                this.index = number
            })
        },

        async save(number) {
            // 店舗問い合わせ登録API
            this.disabled_flg = true
            await axios.post('/shop/contact/save', this.params).then(res => {
                if (res.data.success) {
                    this.slide.next('slideChanged', () => {
                        this.index = number
                    })
                } else {
                    this.disabled_flg = false
                    this.errors = res.data.errors
                }
            }).catch(e => {
                this.disabled_flg = false
                console.log('Error', e)
            })
        },
        checkValidation() {
            // 必須チェック
            this.errors = {}

            // 氏名
            if (!this.params.last_name || !this.params.first_name) {
                this.errors.name = ['氏名を入力してください']
            } else {
                if (this.params.last_name && this.params.last_name.length > 255 ||
                    this.params.first_name && this.params.first_name.length > 255) {
                    this.errors.name = ['氏名は255文字以下で入力してください']
                }
            }
            // 氏名(ローマ字)
            if (!this.params.last_name_romaji || !this.params.first_name_romaji) {
                this.errors.name_romaji = ['氏名(ローマ字)を入力してください']
            } else {
                if (!this.romajiFormatCheck(this.params.last_name_romaji) || !this.romajiFormatCheck(this.params.first_name_romaji)) {
                    this.errors.name_romaji = ['氏名(ローマ字)は半角英字で入力してください']
                } else if (this.params.last_name_romaji && this.params.last_name_romaji.length > 255 ||
                    this.params.first_name_romaji && this.params.first_name_romaji.length > 255) {
                    this.errors.name_romaji = ['氏名(ローマ字)は255文字以下で入力してください']
                }
            }
            // 電話番号
            if (!this.params.tel) {
                this.errors.tel = ['電話番号を入力してください']
            } else if (this.params.tel.length > 255) {
                this.errors.tel = ['電話番号は255文字以下で入力してください']
            }
            // メールアドレス
            if (!this.params.email) {
                this.errors.email = ['メールアドレスを入力してください']
            } else if (this.params.email.length > 255) {
                this.errors.email = ['メールアドレスは255文字以下で入力してください']
            } else if (!this.emailFormatCheck(this.params.email)) {
              this.errors.email = ['メールアドレスの形式が正しくありません']
            }
            // メールアドレス(確認用)
            if (!this.email_confirmation) {
                this.errors.email_confirmation = ['メールアドレス(確認用)を入力してください']
            } else if (this.email_confirmation.length > 255) {
                this.errors.email_confirmation = ['メールアドレス(確認用)は255文字以下で入力してください']
            } else if(!this.emailFormatCheck(this.email_confirmation)) {
                this.errors.email_confirmation = ['メールアドレス(確認用)の形式が正しくありません']
            }
            if (this.params.email && this.email_confirmation) {
                if (this.params.email !== this.email_confirmation) {
                    this.errors.email_confirmation = ['メールアドレスとメールアドレス(確認用)が一致していません。']
                }
            }
            // 宿泊先名
            if (!this.params.hotel_name) {
                this.errors.hotel_name = ['宿泊先を入力してください']
            } else if (this.params.hotel_name.length > 255) {
              this.errors.hotel_name = ['宿泊先は255文字以下で入力してください']
            }
            // お問い合わせ内容
            if (!this.params.content) {
                this.errors.content = ['内容を入力してください']
            } else if (this.params.content.length > 255) {
              this.errors.content = ['内容は255文字以下で入力してください']
            }

            if (!Object.keys(this.errors).length) {
                return true
            } else {
                return false
            }
        },
        romajiFormatCheck(val) {
            if (!/^[a-zA-Z]+$/.test(val)) {
                return false
            }
            return true
        },
        emailFormatCheck(val) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                return false
            }
            return true
        }
    },
    watch: {
        show(val) {
            const searchNav = document.querySelector('.searchAndBottomTabNav')
            if (!val) {
                searchNav.classList.remove('reservationModalOpen')
                return
            } else {
                searchNav.classList.add('reservationModalOpen')
                this.$nextTick(() => {
                    this.initSlide(val)
                })
            }
        }
    }
}
</script>
